export class SafeSearchUtil {
    static GetSetSafeSearchLevel() {
      let safeSearchLevel = "none";
      //firest check if ss is passed in browse, we will not set but it will be session only variable
      const parameters = new URLSearchParams(window.location.search);
      if(parameters.has('ss')) {
        if(parameters.get('ss') == 1) {
          safeSearchLevel = "strict";
        }
      } else {
        let toggledSetting = window.localStorage.getItem('safeSearchToggled'); //return null if it dont exist
        toggledSetting = (toggledSetting == 'true') ? true : false;
        let levelSetting = window.localStorage.getItem('safeSearchLevel'); //return null if it dont exist
        if(levelSetting) {
          safeSearchLevel = levelSetting;
        } else {
          safeSearchLevel = toggledSetting ? "strict" : "none";
        }
      }
      return safeSearchLevel;
    }
}
